define([
    'angular',
    'jquery',
    './controllers/microsite',
    'angulartics',
    'angulartics-google-analytics',
    'angulartics-google-tag-manager',
    '../directives/foundation',
    'angular-google-chart',
    'angular-simple-logger',
    'angular-google-maps',
    '../lead/services/leads',
    '../services/errorHandler',
    '../site/directives/googlePlaces',
    'angular-ui-router',
    '../site/directives/spokesperson',
    '../directives/form',
    'iso-3166-country-codes-angular',
    'jquery-migrate', // Needed for Foundation 5.5.3
    'foundation-sites',
], function (angular, $, micrositeCtrl) {
    'use strict';

    var angularModules = [
        'errorHandlerService',
        'foundationDirectives',
        'googlechart',
        'iso-3166-country-codes',
        'leadServices',
        'google.places',
        'ui.router',
        'uiGmapgoogle-maps',
        'spokespersonDirective',
        'formDirectives',
    ];

    if (window.useGoogleTagManager) {
        angularModules.push('angulartics.google.tagmanager');
    } else {
        angularModules.push('angulartics.google.analytics');
    }

    if (typeof Raven != 'undefined' && Raven) {
        angularModules.push('ngRaven');
    }

    var app = angular
        .module('micrositeApp', angularModules)
        // controllers
        .controller(micrositeCtrl.name, micrositeCtrl.arguments)
        // routes
        .config([
            '$stateProvider',
            '$locationProvider',
            '$urlRouterProvider',
            'uiGmapGoogleMapApiProvider',
            function (
                $stateProvider,
                $location,
                $urlRouterProvider,
                uiGmapGoogleMapApiProvider
            ) {
                uiGmapGoogleMapApiProvider.configure({
                    key: googleMapsKey,
                    v: '3.17',
                    libraries: 'visualization',
                });
                $location.html5Mode({
                    enabled: true,
                    requireBase: false,
                });
                $stateProvider
                    /**
                     * I really dislike all this duplication, but I think it's the
                     * simplest way to get the angular and symfony routing matching.
                     */
                    .state('property_info', {
                        url: Routing.generate('details'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/property_info.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('property_info_with_city', {
                        url: decodeURIComponent(
                            Routing.generate('details_with_city', {
                                forcedCity: ':forcedCity',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/property_info.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('contact_info', {
                        url: Routing.generate('contact_info'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/contact_info.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('contact_info_with_city', {
                        url: decodeURIComponent(
                            Routing.generate('contact_info_with_city', {
                                forcedCity: ':forcedCity',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/contact_info.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('contact_info_additional', {
                        url: Routing.generate('contact_info_additional'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template:
                                            'partials/contact_info_additional.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('contact_info_additional_with_city', {
                        url: decodeURIComponent(
                            Routing.generate(
                                'contact_info_additional_with_city',
                                { forcedCity: ':forcedCity' }
                            )
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template:
                                            'partials/contact_info_additional.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('report', {
                        url: Routing.generate('report'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate('report_partial'),
                            },
                        },
                    })
                    .state('report_with_city', {
                        url: decodeURIComponent(
                            Routing.generate('report_with_city', {
                                forcedCity: ':forcedCity',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate('report_partial'),
                            },
                        },
                    })
                    .state('leadReport', {
                        url: decodeURIComponent(
                            Routing.generate('lead_report', {
                                leadId: ':leadId',
                                addressUrl: ':addressUrl',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate('report_partial'),
                            },
                        },
                    })
                    .state('leadReport_with_city', {
                        url: decodeURIComponent(
                            Routing.generate('lead_report_with_city', {
                                leadId: ':leadId',
                                forcedCity: ':forcedCity',
                                addressUrl: ':addressUrl',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate('report_partial'),
                            },
                        },
                    })
                    .state('confirmation', {
                        url: Routing.generate('confirmation'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/confirmation.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('confirmation_with_city', {
                        url: decodeURIComponent(
                            Routing.generate('confirmation_with_city', {
                                forcedCity: ':forcedCity',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/confirmation.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('privacy_policy', {
                        url: Routing.generate('privacy_policy'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template:
                                            'partials/privacy_policy.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('fair_housing_statement', {
                        url: Routing.generate('fair_housing_statement'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template:
                                            'partials/fair_housing_statement.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('about', {
                        url: Routing.generate('about'),
                        preTitle: 'About | ',
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/about.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('contact', {
                        url: Routing.generate('contact'),
                        preTitle: 'Contact Us | ',
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppSite',
                                        entity: 'Microsite',
                                        template: 'partials/contact.html',
                                    }
                                ),
                            },
                        },
                    })
                    // Putting step 1 last so the forcedCity variable won't match the other routes
                    .state('address', {
                        url: Routing.generate('index'),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                            },
                        },
                    })
                    .state('address_with_city', {
                        url: decodeURIComponent(
                            Routing.generate('index_with_city', {
                                forcedCity: ':forcedCity',
                            })
                        ),
                        views: {
                            body: {
                                controller: 'micrositeCtrl',
                            },
                        },
                    });
                $urlRouterProvider.otherwise(Routing.generate('index'));
            },
        ])
        .run([
            '$http',
            '$rootScope',
            '$timeout',
            function ($http, $rootScope, $timeout) {
                // Expose FOS js routing to all Angular controllers
                $rootScope.Routing = Routing;
                // Make sure foundation's JS components get initialized
                $rootScope.$on('$viewContentLoaded', function () {
                    $(document).foundation();

                    $http
                        .get($rootScope.Routing.generate('background_image'))
                        .then(function (response) {
                            var urls = response.data;

                            /**
                             * This does not swap the image responsively, only changing when a new page
                             * is loaded.  I think that's better than having the background blank out
                             * while resizing to load a new image.
                             */
                            if (
                                $('.wrapper').outerWidth() > 1024 &&
                                urls.desktop
                            ) {
                                $rootScope.wrapperStyle = {
                                    background:
                                        "linear-gradient( rgba(21, 22, 28, 0.1), rgba(21, 22, 28, 0.1) ), url('" +
                                        urls.desktop +
                                        "')",
                                };
                            } else if (urls.mobile) {
                                $rootScope.wrapperStyle = {
                                    background:
                                        "linear-gradient( rgba(21, 22, 28, 0.1), rgba(21, 22, 28, 0.1) ), url('" +
                                        urls.mobile +
                                        "')",
                                };
                            }
                        });
                });

                $rootScope.facebookTracked = window.hasFacebookPixel;
                $rootScope.$on('facebookTracked', function (e, isTracked) {
                    if (isTracked) {
                        $rootScope.facebookTracked = true;
                    } else {
                        // Wait until the next page loads to hide the message
                        $timeout(function () {
                            var cancelOn = $rootScope.$on(
                                '$stateChangeSuccess',
                                function () {
                                    $rootScope.facebookTracked = false;
                                    cancelOn();
                                }
                            );
                        }, 2000);
                    }
                });

                // Update title
                $rootScope.$on('$stateChangeSuccess', function (
                    event,
                    current,
                    previous
                ) {
                    if (current.hasOwnProperty('preTitle')) {
                        $rootScope.preTitle = current.preTitle;
                    } else {
                        $rootScope.preTitle = '';
                    }

                    if (
                        typeof fbq == 'function' &&
                        !window.doNotAutotrackFacebook
                    ) {
                        fbq('track', 'PageView');
                        $rootScope.facebookTracked = true;
                    }
                });

                $rootScope.cookieNoticeDismissed = false;
                $rootScope.dismissCookieNotice = function () {
                    $rootScope.cookieNoticeDismissed = true;
                };
            },
        ]);
    return app;
});
